export default __webpack_public_path__ + "static/media/jewelry-soft-autumn.3dd8d9a1.png";